var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-8 mb-2 font-weight-bold"
  }, [_vm._v("預購單設定檔列表")]), _c('b-input-group', {
    staticClass: "col-12 col-xl-4 mb-2"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.PREORDER_SETTING_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'PreorderSettingCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增預購單設定檔 ")]) : _vm._e()], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.preorderSettings,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(is_enabled)",
      fn: function fn(data) {
        return [data.item.is_enabled == true ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" 啟用 ")]) : _vm._e(), data.item.is_enabled == false ? _c('b-badge', {
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(" 停用 ")]) : _vm._e()];
      }
    }, {
      key: "cell(start_end_time)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(data.item.start_at)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(data.item.end_at)) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-dark"
          },
          on: {
            "click": function click($event) {
              return _vm.showFormUrl(data.item);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-link"
        })]), _c('b-modal', {
          attrs: {
            "id": "modal-".concat(data.item.id)
          },
          scopedSlots: _vm._u([{
            key: "modal-header",
            fn: function fn(_ref) {
              var close = _ref.close;
              return [_c('h5', {
                staticClass: "m-0 align-self-center"
              }, [_vm._v(" " + _vm._s(data.item.title) + " ")]), _c('b-button', {
                staticClass: "text-dark",
                attrs: {
                  "size": "sm",
                  "variant": "link"
                },
                on: {
                  "click": function click($event) {
                    return close();
                  }
                }
              }, [_c('svg', {
                staticStyle: {
                  "height": "20px"
                },
                attrs: {
                  "xmlns": "http://www.w3.org/2000/svg",
                  "viewBox": "0 0 320 512"
                }
              }, [_c('path', {
                attrs: {
                  "d": "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                }
              })])])];
            }
          }, {
            key: "modal-footer",
            fn: function fn() {
              return [_c('div', {
                staticClass: "modal-button-group"
              }, [_c('b-button', {
                staticClass: "center-button",
                attrs: {
                  "variant": "primary"
                },
                on: {
                  "click": function click($event) {
                    return _vm.downloadQRCode(data.item.title);
                  }
                }
              }, [_vm._v(" 下載QRCode ")]), _c('b-button', {
                attrs: {
                  "variant": "danger"
                },
                on: {
                  "click": function click($event) {
                    return _vm.$bvModal.hide("modal-".concat(data.item.id));
                  }
                }
              }, [_vm._v(" 關閉 ")])], 1)];
            },
            proxy: true
          }], null, true)
        }, [_c('div', {
          staticClass: "d-flex flex-column align-items-center"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("預購網址")]), _c('b-textarea', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            value: '已複製',
            expression: "'已複製'",
            modifiers: {
              "click": true
            }
          }],
          attrs: {
            "id": "form-url"
          },
          on: {
            "click": function click($event) {
              return _vm.copyFormUrl('#form-url');
            }
          },
          model: {
            value: _vm.formUrl,
            callback: function callback($$v) {
              _vm.formUrl = $$v;
            },
            expression: "formUrl"
          }
        }), _c('div', [_c('vue-qr', {
          ref: "qrcode",
          attrs: {
            "text": _vm.formUrl
          }
        })], 1)], 1)]), _vm.checkPermission([_vm.consts.PREORDER_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-success",
            "to": {
              name: 'PreorderList',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-list"
        }), _vm._v(" 預購單列表 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PREORDER_SETTING_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'PreorderSettingEdit',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PREORDER_SETTING_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deletePreorderSetting(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }